export enum DestinationEnum {
    None = 'none',
    Full = 'full',
    IntlDom = 'intl-dom'
}
